import React from 'react';
import { Form, Button, Header, Icon } from 'semantic-ui-react';
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';

import { DateTime } from 'luxon';

export default function SaldosForm({
    empresas,
    formSaldos,
    setFormSaldos,
    match,
    history,
}) {


    const handleChange = (event, props) => {
        let name, value;
        if (!props) [name, value] = [event.target.name, event.target.value];
        else {
            name = props.name;
            value = props.value;
        }
        setFormSaldos({ payload: { [name]: value } });
    };


    const handleSubmit = () => {
        const dataInicial = DateTime.fromFormat(formSaldos.dataIni, 'dd/MM/yyyy')
        const dataFinal = DateTime.fromFormat(formSaldos.dataFim, 'dd/MM/yyyy')

        const diferencaData = dataInicial.diff(dataFinal).as('milliseconds');

        if (!!!formSaldos.empresa || !!!formSaldos.dataIni || !!!formSaldos.dataFim) {
            toast.error('Há campos não preenchidos.', {
                toastId: 'errorCamposVazios',
            });
        } else if (diferencaData > 0) {
            toast.error('Data Inicial maior que data Final.', {
                toastId: 'errorData',
            })
        } else if (!dataInicial.isValid || !dataFinal.isValid) {
            toast.error('Formato de data inválido.', {
                toastId: 'errorDataFormat',
            })
        }
        else {
            history.push(
                `${match.path}/saldos?=${new URLSearchParams(formSaldos).toString()}`,
            );
        }

    };

    //useSubscription(submitFormSaldos$, isSubmiting);

    return (
        <div className="col d-flex flex-column flex-grow-1">
            <Header as="h3">
                <Icon.Group size="big">
                    <Icon name="clipboard list" className="primary-color" />
                </Icon.Group>
                <Header.Content className="primary-color">
                    Saldos
                    <Header.Subheader className="secondary-color">
                        <strong>Análise de Saldos</strong>
                    </Header.Subheader>
                </Header.Content>
            </Header>
            <div className="d-flex flex-column flex-grow-1 align-items-center justify-content-center">
                <Form
                    size="mini"
                    className="w-75"
                    onSubmit={handleSubmit}
                    //    loading={isSubmiting}
                    noValidate
                >
                    <div className="row mt-2">
                        <div className="col">
                            <Form.Select
                                search
                                noResultsMessage="Nenhum resultado encontrado"
                                required
                                label="Empresa"
                                placeholder="Selecionar empresa"
                                name="empresa"
                                value={formSaldos.empresa}
                                onChange={handleChange}
                                selectOnBlur={false}
                                options={
                                    empresas
                                        ? empresas
                                            .filter((x) => x.ativo === 1 && x.tipo === 'POSTO')
                                            .map((x) => ({
                                                text: x.codDpnet + ' - ' + x.nomeEmpresa,
                                                value: x.codDpnet,
                                            }))
                                        : []
                                }
                            />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col">
                            <InputMask
                                mask="99/99/9999"
                                name="dataIni"
                                value={formSaldos.dataIni}
                                onChange={handleChange}
                            >
                                {(inputProps) => (
                                    <Form.Input
                                        {...inputProps}
                                        required
                                        label="Data Inicial"
                                        placeholder="Informar data inicial"
                                    />
                                )}
                            </InputMask>
                        </div>
                        <div className="col">
                            <InputMask
                                mask="99/99/9999"
                                name="dataFim"
                                value={formSaldos.dataFim}
                                onChange={handleChange}
                            >
                                {(inputProps) => (
                                    <Form.Input
                                        {...inputProps}
                                        required
                                        label="Data Final"
                                        placeholder="Informar data final"
                                    />
                                )}
                            </InputMask>
                        </div>
                    </div>
                    <div className="row pt-3">
                        <div className="col text-center">
                            <Button size="mini" color="green">
                                Buscar
                            </Button>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    );
}
